.container {
  display: flex;
  align-items: center;
}

.container svg {
  width: 31px;
  fill: var(--main-text);
  cursor: pointer;
  padding: 0 6px;
}

.container .input {
  border: 0;
  padding: 5px 6px;
  color: var(--button-text);
  width: inherit;
}

.container input.small {
  width: 60px;
}

.container.full {
  width: 100%;
}

.svg-container {
  display: flex;
}

.inner-container {
  position: relative;
  background-color: white;
  display: flex;
  align-items: center;
  width: fit-content;
  border-right: 1px solid var(--field-border);
}

.border-left {
  border-left: 1px solid var(--field-border);
}

.border-left-transparent {
  border-left: 1px solid transparent;
}

.time-picker {
  position: absolute;
}

.time-picker-wrapper {
  z-index: 100;
  position: absolute;
  transform: scale(0.7) translateY(20px);
}

.time-picker-container {
  top: 2px;
  left: -2px;
  user-select: none;
  position: absolute;
  background-color: white;
  box-shadow: 4px 4px 30px 0 rgb(0 0 0 / 20%);
}
